// Croqui: `components/Input.tsx`.
//
// WEB-133: é o `Input` de `components/ui` dentro do `InputGroup` (a casca de campo do
// sistema), com a API do kit: ícone à esquerda e conteúdo colado à direita.

import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import { cn } from '../../lib/cn.ts';
import { InputAddon, InputGroup, Input as UiInput } from '../ui/input.tsx';
import { Icon, type IconName } from './icon.tsx';

export function Input({
  icon,
  right,
  mono = false,
  className,
  inputClassName,
  ref,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> & {
  icon?: IconName;
  /** Conteúdo colado à direita: badge, unidade, botão de copiar. */
  right?: ReactNode;
  mono?: boolean;
  className?: string;
  inputClassName?: string;
  ref?: Ref<HTMLInputElement>;
}) {
  return (
    <InputGroup className={className}>
      {icon !== undefined && (
        <InputAddon>
          <Icon name={icon} size={16} />
        </InputAddon>
      )}
      <UiInput
        {...(ref === undefined ? {} : { ref })}
        className={cn(mono && 'font-mono', inputClassName)}
        {...props}
      />
      {right}
    </InputGroup>
  );
}
